import { render, staticRenderFns } from "./roleInfo.vue?vue&type=template&id=da52c8a8&scoped=true&"
import script from "./roleInfo.vue?vue&type=script&lang=js&"
export * from "./roleInfo.vue?vue&type=script&lang=js&"
import style0 from "./roleInfo.vue?vue&type=style&index=0&id=da52c8a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da52c8a8",
  null
  
)

export default component.exports